import { guidEmpty } from "utils/guid-empty";

export class ParametroSistemaModel {
    constructor(
        public id: string = guidEmpty(),
        public sistemaId: string = guidEmpty(),
        public nome: string = '',
        public valor: string = '',
    ) { }
}